// ##### 24-06-13 Komarov
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
// ##### Komarov 2025-07-18
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';
import useValidateQuery from '../../../../../helpers/useValidateQuery.js';
import { setCounterAdultsOuter, setCounterChildOuter, setCounterRoomsOuter } from '../../../../../Redux/actions/hotelsContext.js';
// ##### Komarov 2025-07-19
import { setCounterAdults, setCounterChild, setCounterRooms } from '../../../../../Redux/actions/paxchoice.js';

// ##### Komarov 2025-07-18
const HotelsPaxChoiceGrid = ({ rowGap }) => {
  // ##### Komarov 2025-08-05
  const twelve_plus_years = useLocalizedText('twelve_plus_years');
  const two_eleven_years = useLocalizedText('two_eleven_years');
  // ##### 24-05-10 Komarov
  const Adults = useLocalizedText('Adults');
  const Children = useLocalizedText('Children');
  const Rooms = useLocalizedText('Rooms');

  // ##### Komarov 2025-07-18
  const { adults: counterAdults, children: counterChild, rooms: counterRooms } = useSelector(state => state.paxchoice.pax);
  const totalPaxReduxAdults = useSelector(state => state.paxchoice.pax.adults);
  const totalPaxReduxChildren = useSelector(
    state => state.paxchoice.pax.children
  );
  const totalPaxReduxRooms = useSelector(state => state.paxchoice.pax.rooms);
  const searchProps = useValidateQuery();

  const dispatch = useDispatch();

  // ##### Komarov 2025-07-21
  useEffect(() => {
    dispatch(setCounterAdults(searchProps?.adults
      ? parseInt(searchProps?.adults)
      : totalPaxReduxAdults || 1));
  }, []);

  useEffect(() => {
    dispatch(setCounterChild(searchProps?.children
      ? parseInt(searchProps?.children)
      : totalPaxReduxChildren || 0));
  }, []);

  useEffect(() => {
    dispatch(setCounterRooms(searchProps?.rooms
      ? parseInt(searchProps?.rooms)
      : totalPaxReduxRooms || 1));
  }, []);

  const addAdults = () => {
    dispatch(setCounterAdults(counterAdults + 1));
    // ##### 23-08-07 Komarov
    dispatch(setCounterAdultsOuter(counterAdults + 1));
  };

  const deductAdults = () => {
    counterAdults > 2
      ? dispatch(setCounterAdults(counterAdults - 1))
      : dispatch(setCounterAdults(1));
    // ##### 24-05-13 Komarov
    counterAdults > 2
      ? dispatch(setCounterAdultsOuter(counterAdults - 1))
      : dispatch(setCounterAdultsOuter(1));
  };

  const addChild = () => {
    // counterChild<2? setCounterChild(counterChild+1) : alert('This tour allows upto 2 Children')
    dispatch(setCounterChild(counterChild + 1));
    // ##### 23-08-07 Komarov
    dispatch(setCounterChildOuter(counterChild + 1));
  };
  const deductChild = () => {
    counterChild > 1 ? dispatch(setCounterChild(counterChild - 1)) : dispatch(setCounterChild(0));
    // ##### 23-08-07 Komarov
    counterChild > 1
      ? dispatch(setCounterChildOuter(counterChild - 1))
      : dispatch(setCounterChildOuter(0));
  };

  const addRooms = () => {
    // counterInfant<1? setCounterInfant(counterInfant+1) : alert('This tour allows upto 1 Infant')
    dispatch(setCounterRooms(counterRooms + 1));
    // ##### 23-08-07 Komarov
    dispatch(setCounterRoomsOuter(counterRooms + 1));
  };
  const deductRooms = () => {
    counterRooms > 1 ? dispatch(setCounterRooms(counterRooms - 1)) : dispatch(setCounterRooms(1));
    // ##### 23-08-07 Komarov
    counterRooms > 1
      ? dispatch(setCounterRoomsOuter(counterRooms - 1))
      : dispatch(setCounterRoomsOuter(1));
  };

  return (
    <div
      data-component="HotelsPaxChoiceGrid"
      style={{
        display: 'grid',
        gridTemplateRows: 'repeat(3, 6vh)',
        rowGap,
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '25% 17% 16% 17% 25%',
        }}
      >
        <h4>
          {
            // ##### 23-10-04 Komarov
            Adults
          }
        </h4>
        {/* ##### 24-02-08 Komarov */}
        <h4>
          <MinusOutlined
            className="Minus"
            style={{ color: 'white' }}
            onClick={deductAdults}
          />
        </h4>
        <h4>
          <center>
            <b>{counterAdults}</b>
          </center>
        </h4>
        {/* ##### 24-02-08 Komarov */}
        <h4>
          <PlusOutlined
            className="Plus"
            style={{ color: 'white' }}
            onClick={addAdults}
          />
        </h4>
        {/* ##### 23-07-06 Komarov */}
        <h4>
          <center>
            <i>
              (
              {
                // ##### 23-10-04 Komarov
                twelve_plus_years
              }
              )
            </i>
          </center>
        </h4>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '25% 17% 16% 17% 25%',
        }}
      >
        <h4>
          {
            // ##### 23-10-04 Komarov
            Children
          }
        </h4>
        {/* ##### 24-02-08 Komarov */}
        <h4>
          <MinusOutlined
            className="Minus"
            style={{ color: 'white' }}
            onClick={deductChild}
          />
        </h4>
        <h4>
          <center>
            <b>{counterChild}</b>
          </center>
        </h4>
        {/* ##### 24-02-08 Komarov */}
        <h4>
          <PlusOutlined
            className="Plus"
            style={{ color: 'white' }}
            onClick={addChild}
          />
        </h4>
        {/* ##### 23-09-14 Komarov */}
        <h4>
          <center>
            <i>
              (
              {
                // ##### 23-10-04 Komarov
                two_eleven_years
              }
              )
            </i>
          </center>
        </h4>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '25% 17% 16% 17% 25%',
        }}
      >
        <h4>
          {
            // ##### 23-10-04 Komarov
            Rooms
          }
        </h4>
        {/* ##### 24-02-08 Komarov */}
        <h4>
          <MinusOutlined
            className="Minus"
            style={{ color: 'white' }}
            onClick={deductRooms}
          />
        </h4>
        <h4>
          <center>
            <b>{counterRooms}</b>
          </center>
        </h4>
        {/* ##### 24-02-08 Komarov */}
        <h4>
          <PlusOutlined
            className="Plus"
            style={{ color: 'white' }}
            onClick={addRooms}
          />
        </h4>
      </div>
    </div>
  );
};

export default HotelsPaxChoiceGrid;
